

// ********************************* vrai et faux crois rouge !!! *************
import React, { useState, useEffect } from "react";
import courseService from "../../services/course.service";
import { Card, Radio, Checkbox, Button, Select, message, Alert } from "antd";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";


const { Option } = Select;

const QuizComponent = ({ quizId, onQuizSubmit }) => {
    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [results, setResults] = useState([]);
    const [correctAnswers, setCorrectAnswers] = useState({}); // Stocke les bonnes réponses
    const [answersOrder, setAnswersOrder] = useState({});

    useEffect(() => {
        const fetchQuestions = async () => {
            try {
                const response = await courseService.getQuestionsByQuiz(quizId);
                console.log("Questions récupérées :", response);
                setQuestions(response);

                // Stocker les réponses correctes en base de données
                const correctMap = {};
                response.forEach((question) => {
                    correctMap[question.id] = question.answers.filter(a => a.isCorrect).map(a => a.id);
                });
                setCorrectAnswers(correctMap);

            } catch (error) {
                console.error("Erreur lors de la récupération des questions :", error);
            }
        };

        if (quizId) {
            fetchQuestions();
        }
    }, [quizId]);


    useEffect(() => {
        const fetchQuestions = async () => {
            try {
                const response = await courseService.getQuestionsByQuiz(quizId);
                setQuestions(response);

                let initialOrder = {};
                let correctMap = {};

                response.forEach((question) => {
                    if (question.questionType === "DRAG_DROP") {
                        if (!question.answers || question.answers.length === 0) return;

                        // 🛠️ Assurer que les réponses sont triées par `order_index` avant stockage
                        let sortedAnswers = [...question.answers].sort((a, b) => a.orderIndex - b.orderIndex);
                        let sortedIds = sortedAnswers.map(a => Number(a.id));

                        initialOrder[question.id] = sortedAnswers; // ✅ Stocker l'ordre initial
                        correctMap[question.id] = sortedIds; // ✅ Stocker l'ordre correct sous forme de tableau d'IDs
                    } else {
                        correctMap[question.id] = question.answers.filter(a => a.isCorrect).map(a => a.id);
                    }
                });

                setAnswersOrder(initialOrder);
                setCorrectAnswers(correctMap);
            } catch (error) {
                console.error("Erreur lors de la récupération des questions :", error);
            }
        };

        if (quizId) {
            fetchQuestions();
        }
    }, [quizId]);

    const handleChange = (questionId, value) => {
        setAnswers({ ...answers, [questionId]: value });
    };

    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const questionId = result.source.droppableId;
        if (!answersOrder[questionId]) return;

        // Réorganiser les réponses en fonction du drag & drop
        const reorderedItems = [...answersOrder[questionId]];
        const [movedItem] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, movedItem);

        setAnswersOrder((prev) => ({
            ...prev,
            [questionId]: reorderedItems,
        }));

        console.log(`✅ Nouvel ordre soumis pour la question ${questionId} :`, reorderedItems.map(a => a.id));
    };

    // const handleSubmit = async () => {
    //     const formattedAnswers = Object.keys(answersOrder).map((questionId) => ({
    //         questionId: parseInt(questionId),
    //         selectedAnswerIds: answersOrder[questionId]?.map(a => Number(a.id)) || [],
    //     }));

    //     try {
    //         const response = await courseService.submitQuizAnswers(quizId, formattedAnswers);
    //         setResults(response);
    //         setSubmitted(true);
    //         message.success("Quiz soumis avec succès !");

    //         let isQuizCorrect = true;

    //         Object.keys(answersOrder).forEach((questionId) => {
    //             const correctOrder = correctAnswers[questionId] || [];
    //             const userOrder = answersOrder[questionId]?.map(a => Number(a.id)) || [];

    //             console.log(`🔍 Comparaison pour question ${questionId}`);
    //             console.log("✅ Ordre attendu :", JSON.stringify(correctOrder));
    //             console.log("❓ Ordre soumis :", JSON.stringify(userOrder));

    //             if (JSON.stringify(userOrder) !== JSON.stringify(correctOrder)) {
    //                 console.warn(`❌ Mauvais ordre pour la question ${questionId}`);
    //                 isQuizCorrect = false;
    //             } else {
    //                 console.log(`✅ Bonne réponse pour la question ${questionId}`);
    //             }
    //         });

    //         console.log("Résultat du quiz :", isQuizCorrect);
    //         if (onQuizSubmit) {
    //             onQuizSubmit(isQuizCorrect);
    //         }
    //     } catch (error) {
    //         message.error("Erreur lors de l'enregistrement des réponses.");
    //     }
    // };

    // faire fonctionnée vrai et fax *****
    // const handleSubmit = async () => {
    //     const formattedAnswers = Object.keys(answers).map((questionId) => ({
    //         questionId: parseInt(questionId),
    //         selectedAnswerIds: Array.isArray(answers[questionId])
    //             ? answers[questionId].map(Number)
    //             : [Number(answers[questionId])]
    //     }));

    //     const dragDropAnswers = Object.keys(answersOrder).map((questionId) => ({
    //         questionId: parseInt(questionId),
    //         selectedAnswerIds: answersOrder[questionId]?.map(a => Number(a.id)) || [],
    //     }));

    //     const allAnswers = [...formattedAnswers, ...dragDropAnswers];

    //     try {
    //         const response = await courseService.submitQuizAnswers(quizId, allAnswers);
    //         setResults(response);
    //         setSubmitted(true);
    //         message.success("Quiz soumis avec succès !");

    //         let isQuizCorrect = true;

    //         questions.forEach((question) => {
    //             const correct = correctAnswers[question.id] || [];
    //             const user =
    //                 question.questionType === "DRAG_DROP"
    //                     ? (answersOrder[question.id]?.map(a => Number(a.id)) || [])
    //                     : Array.isArray(answers[question.id])
    //                         ? answers[question.id].map(Number)
    //                         : [Number(answers[question.id])];

    //             const isCorrect =
    //                 question.questionType === "QCM" || question.questionType === "DRAG_DROP"
    //                     ? JSON.stringify(user.sort()) === JSON.stringify(correct.sort())
    //                     : correct.includes(user[0]);

    //             if (!isCorrect) {
    //                 isQuizCorrect = false;
    //             }
    //         });

    //         console.log("✅ Résultat du quiz (vrai calcul):", isQuizCorrect);
    //         if (onQuizSubmit) {
    //             onQuizSubmit(isQuizCorrect);
    //         }
    //     } catch (error) {
    //         message.error("Erreur lors de l'enregistrement des réponses.");
    //     }
    // };


    //// faire fonctionnées les deux **********

    const handleSubmit = async () => {
        // Réponses classiques (QCU, QCM, VRAI_FAUX, etc.)
        const formattedAnswers = Object.keys(answers).map((questionId) => ({
            questionId: parseInt(questionId),
            selectedAnswerIds: Array.isArray(answers[questionId])
                ? answers[questionId].map(Number)
                : [Number(answers[questionId])]
        }));

        // Réponses de type DRAG_DROP
        const dragDropAnswers = Object.keys(answersOrder).map((questionId) => ({
            questionId: parseInt(questionId),
            selectedAnswerIds: answersOrder[questionId]?.map(a => Number(a.id)) || [],
        }));

        // Combinaison complète
        const allAnswers = [...formattedAnswers, ...dragDropAnswers];

        try {
            const response = await courseService.submitQuizAnswers(quizId, allAnswers);
            setResults(response);

            // 🔁 Mettre à jour les réponses DRAG_DROP dans `answers` pour affichage post-submit
            let updatedAnswers = { ...answers };
            Object.keys(answersOrder).forEach((questionId) => {
                updatedAnswers[questionId] = answersOrder[questionId]?.map(a => Number(a.id));
            });
            setAnswers(updatedAnswers);

            setSubmitted(true);
            message.success("Quiz soumis avec succès !");

            let isQuizCorrect = true;

            questions.forEach((question) => {
                const correct = correctAnswers[question.id] || [];

                let user = [];
                if (question.questionType === "DRAG_DROP") {
                    user = answersOrder[question.id]?.map(a => Number(a.id)) || [];
                } else if (Array.isArray(answers[question.id])) {
                    user = answers[question.id].map(Number);
                } else {
                    user = [Number(answers[question.id])];
                }

                const isCorrect =
                    question.questionType === "QCM"
                        ? JSON.stringify([...user].sort()) === JSON.stringify([...correct].sort())
                        : question.questionType === "DRAG_DROP"
                            ? JSON.stringify(user) === JSON.stringify(correct) // 💡 ordre strict pour DRAG_DROP
                            : correct.includes(user[0]);

                console.log(`🔍 Question ${question.id}`);
                console.log("Réponse attendue :", correct);
                console.log("Réponse utilisateur :", user);
                console.log("✅ Est correcte ?", isCorrect);

                if (!isCorrect) {
                    isQuizCorrect = false;
                }
            });

            console.log("✅ Résultat final du quiz :", isQuizCorrect);
            if (onQuizSubmit) {
                onQuizSubmit(isQuizCorrect);
            }
        } catch (error) {
            message.error("Erreur lors de l'enregistrement des réponses.");
        }
    };


    return (
        <div>
            <h2>Quiz</h2>
            {questions.map((question) => {
                console.log("Type de question :", question.questionType);

                const selectedAnswer = answers[question.id];
                const correctAnswer = correctAnswers[question.id] || [];

                // Vérifier si la réponse soumise correspond à la bonne réponse
                const isCorrect =
                    question.questionType === "QCM"
                        ? selectedAnswer && Array.isArray(selectedAnswer) && selectedAnswer.every(id => correctAnswer.includes(id)) && selectedAnswer.length === correctAnswer.length
                        : correctAnswer.includes(selectedAnswer);

                return (

                    // <Card key={question.id} title={question.text} style={{ marginBottom: "10px" }}>
                    <Card
                        key={question.id}
                        style={{ marginBottom: "10px" }}
                        title={
                            <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                                {question.text}
                            </div>
                        }
                    >

                        {!submitted ? (
                            question.questionType === "DRAG_DROP" ? (
                                <DragDropContext onDragEnd={handleDragEnd}>
                                    <Droppable droppableId={String(question.id)}>
                                        {(provided) => (
                                            <div ref={provided.innerRef} {...provided.droppableProps}>
                                                {answersOrder[question.id]?.map((answer, index) => (
                                                    <Draggable key={String(answer.id)} draggableId={String(answer.id)} index={index}>
                                                        {(provided) => (
                                                            <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                    padding: "12px",
                                                                    marginBottom: "5px",
                                                                    backgroundColor: "#fafafa",
                                                                    border: "1px solid #ddd",
                                                                    borderRadius: "6px",
                                                                    fontSize: "16px",
                                                                    cursor: "grab",
                                                                    ...provided.draggableProps.style,
                                                                }}
                                                            >
                                                                {answer.text}
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                ))}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            )
                                :
                                question.questionType === "QCM" ? (
                                    <Checkbox.Group
                                        options={question.answers.map((a) => ({ label: a.text, value: a.id }))}
                                        onChange={(values) => handleChange(question.id, values)}
                                    />
                                ) : question.questionType === "VRAI_FAUX" ? (
                                    <Radio.Group
                                        onChange={(e) => handleChange(question.id, e.target.value)}
                                        value={answers[question.id]}
                                    >
                                        {question.answers.map((answer) => (
                                            <Radio key={answer.id} value={answer.id} style={{ fontWeight: "bold" }}>
                                                {answer.text}
                                            </Radio>
                                        ))}
                                    </Radio.Group>
                                ) : question.questionType === "QCU" ? (
                                    <Radio.Group
                                        options={question.answers.map((a) => ({ label: a.text, value: a.id }))}
                                        onChange={(e) => handleChange(question.id, e.target.value)}
                                    />
                                ) : (
                                    <Select
                                        placeholder="Sélectionnez une réponse"
                                        onChange={(value) => handleChange(question.id, value)}
                                        style={{ width: "100%" }}
                                    >
                                        {question.answers.map((a) => (
                                            <Option key={a.id} value={a.id}>
                                                {a.text}
                                            </Option>
                                        ))}
                                    </Select>
                                )
                        ) : (
                            <div>
                                {/* {question.answers.map((answer) => {
                                    const isSelected = answers[question.id] === answer.id;
                                    const isCorrect = answer.isCorrect; // Vérifie si la réponse est correcte

                                    return (
                                        <div
                                            key={answer.id}
                                            style={{
                                                padding: "5px",
                                                borderRadius: "5px",
                                                marginBottom: "5px",
                                                backgroundColor: isSelected
                                                    ? isCorrect
                                                        ? "#d4edda"
                                                        : "#f8d7da"
                                                    : "#f1f1f1",
                                            }}
                                        >
                                            {answer.text}{" "}
                                            {isCorrect ? (
                                                <CheckCircleTwoTone twoToneColor="#52c41a" />
                                            ) : (
                                                <CloseCircleTwoTone twoToneColor="#ff4d4f" />
                                            )}
                                        </div>
                                    );
                                })} */}
                                {question.answers.map((answer) => {
                                    const isSelected = answers[question.id] === answer.id;
                                    const isCorrect = answer.isCorrect;

                                    let icon = null;

                                    if (isSelected && isCorrect) {
                                        icon = <CheckCircleTwoTone twoToneColor="#52c41a" />; // ✅ Bien répondu
                                    } else if (isSelected && !isCorrect) {
                                        icon = <CloseCircleTwoTone twoToneColor="#ff4d4f" />; // ❌ Mauvaise réponse choisie
                                    } else if (!isSelected && isCorrect) {
                                        icon = <CheckCircleTwoTone twoToneColor="#52c41a" />; // ✅ Bonne réponse à montrer
                                    }

                                    return (
                                        <div
                                            key={answer.id}
                                            style={{
                                                padding: "5px",
                                                borderRadius: "5px",
                                                marginBottom: "5px",
                                                backgroundColor: isSelected
                                                    ? isCorrect
                                                        ? "#d4edda"
                                                        : "#f8d7da"
                                                    : "#f1f1f1",
                                            }}
                                        >
                                            {answer.text} {icon}
                                        </div>
                                    );
                                })}

                                {/* ✅ Correction du message pour VRAI/FAUX */}

                                <Alert
                                    message={
                                        question.questionType === "DRAG_DROP"
                                            ? JSON.stringify(answersOrder[question.id]?.map(a => Number(a.id))) === JSON.stringify(correctAnswers[question.id])
                                                ? "Bonne réponse !"
                                                : "Mauvaise réponse !"
                                            : question.questionType === "QCU" || question.questionType === "VRAI_FAUX"
                                                ? correctAnswers[question.id]?.includes(Number(answers[question.id])) // Vérifier directement pour QCU et VRAI_FAUX
                                                    ? "Bonne réponse !"
                                                    : "Mauvaise réponse !"
                                                : Array.isArray(answers[question.id]) && JSON.stringify([...answers[question.id]].sort()) === JSON.stringify([...correctAnswers[question.id]].sort())
                                                    ? "Bonne réponse !"
                                                    : "Mauvaise réponse !"
                                    }
                                    description={
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: question.explanation || "Pas d'explication disponible.",
                                            }}
                                        />
                                    }
                                    type={
                                        question.questionType === "DRAG_DROP"
                                            ? JSON.stringify(answersOrder[question.id]?.map(a => Number(a.id))) === JSON.stringify(correctAnswers[question.id])
                                                ? "success"
                                                : "error"
                                            : question.questionType === "QCU" || question.questionType === "VRAI_FAUX"
                                                ? correctAnswers[question.id]?.includes(Number(answers[question.id]))
                                                    ? "success"
                                                    : "error"
                                                : Array.isArray(answers[question.id]) && JSON.stringify([...answers[question.id]].sort()) === JSON.stringify([...correctAnswers[question.id]].sort())
                                                    ? "success"
                                                    : "error"
                                    }
                                    showIcon
                                    style={{ marginTop: "10px" }}
                                />



                            </div>
                        )}
                    </Card>

                );
            })}
            {!submitted && (
                <Button type="primary" onClick={handleSubmit} style={{ marginTop: "20px" }}>
                    Soumettre le Quiz
                </Button>
            )}
        </div>
    );
};

export default QuizComponent;